import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import kutil, { registerProgressStore, registerAuthStore, registerSettingsStore, registerTabsStore } from "@modules/kutil";
import commonCode, { type Code } from "@modules/common_code";
import valueFormatter from "@modules/value_formatter";
import config from "@modules/config";

import { useProgressStore } from "@components/progress/progress_store";
import { useAuthStore } from "@user/store/auth_store";
import { useSettingsStore } from "@user/store/settings_store";
import { useTabsStore, registerRouteResolver } from "@user/store/tabs_store";

import { resolveRoute } from "@user/routes";

import "@user/assets/css/common.scss";

import App from "@user/App";

// router
registerRouteResolver(resolveRoute);

// store
registerProgressStore(() => useProgressStore.getState());
registerAuthStore(() => useAuthStore.getState());
registerSettingsStore(() => useSettingsStore.getState());
registerTabsStore(() => useTabsStore.getState());

async function init() {
  try {
    if (config.get("auth.useApigee") == "true") {
      while(true) {
        const ret = await kutil.getRefreshToken();
        if (ret) {
          break;
        }
        await kutil.sleep(3000);
      }
    }
    while(true) {
      const ret = await useAuthStore.getState().init();
      if (ret) {
        break;
      }
      await kutil.sleep(3000);
    }
    while(true) {
      const ret = await useSettingsStore.getState().init();
      if (ret) {
        break;
      }
      await kutil.sleep(3000);
    }
    while(true) {
      const ret = await useTabsStore.getState().init();
      if (ret) {
        break;
      }
      await kutil.sleep(3000);
    }
    while(true) {
      const ret = await commonCode.initCommonCodes();;
      if (ret) {
        break;
      }
      await kutil.sleep(3000);
    }
  } finally {
  }
}

await init();

createRoot(document.getElementById("app")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
